import config from "@config";

export const getUiSchema = ({
  t,
  fileName,
}: {
  t: (id: string, obj?: Object) => string,
  fileName?: string,
}) => {
  return {
    additionalNotes: {
      "ui:widget": "textarea",
      "ui:options": {
        fieldOverflow: "unset",
      },
    },
    reasonForAppeal: {
      id: {
        "ui:options": {
          fieldOverflow: "unset",
        },
      },
    },
    dateReceived: {
      "ui:header": t("APPEAL_DETAILS"),
      "ui:widget": "date-picker",
      "ui:options": {
        dateFormat: config.dateTimeFormat,
        fieldOverflow: "unset",
        header: {
          backgroundColor: "white",
          type: "h5",
          padding: "0",
        },
      },
    },
    appealForm: {
      "ui:widget": "file-input",
      "ui:options": {
        accept: [
          "application/pdf",
          "application/zip",
          "text/csv",
          "text/plain",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          "application/vnd.ms-excel",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-powerpoint",
          "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        ].join(","),
        fileName,
      },
    },
  };
};
